import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";
import type { LessonRuleRef } from "site/services/zepto-editor";

export type EditorLessonRulesModalRef = LessonRuleRef & {
  label: string;
};

export type EditorLessonRulesModalContext = {
  refs: EditorLessonRulesModalRef[];
  onGoToRow: (rowId: number) => void;
};

let context: EditorLessonRulesModalContext | null = null;

export function openEditorLessonRulesModal(next: EditorLessonRulesModalContext): void {
  context = next;
  ModalComponent.attach("editorLessonRulesModal", appScope.id);
}

export function getEditorLessonRulesModalContext(): EditorLessonRulesModalContext | null {
  return context;
}

export function clearEditorLessonRulesModalContext(): void {
  context = null;
}
